var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('el-pagination',{attrs:{"page-size":_vm.size,"layout":"total, prev, pager, next","total":_vm.total,"current-page":_vm.currentPage1},on:{"current-change":_vm.onCurrentChange,"update:currentPage":function($event){_vm.currentPage1=$event}}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c33f0b9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/pagination.vue
// module id = null
// module chunks = 